import { useState, useEffect, useRef } from 'react';
export default function useComponentVisible(initialIsVisible) {
    var _a = useState(initialIsVisible), isVisible = _a[0], setIsVisible = _a[1];
    var parentRef = useRef(null);
    var toggleRef = useRef(null);
    var handleClickOutside = function (event) {
        var _a, _b, _c;
        if ((_a = toggleRef === null || toggleRef === void 0 ? void 0 : toggleRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) {
            setIsVisible(!isVisible);
        }
        else {
            if ((_b = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) === null || _b === void 0 ? void 0 : _b.contains) {
                setIsVisible((_c = parentRef.current) === null || _c === void 0 ? void 0 : _c.contains(event.target));
            }
        }
    };
    useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });
    return { parentRef: parentRef, toggleRef: toggleRef, isVisible: isVisible, setIsVisible: setIsVisible };
}
